var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"depressed":"","color":"darken-2 ml-5","title":'Export ' + _vm.name,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":function($event){return _vm.exportCSV()}}},[_c('v-icon',[_vm._v("mdi-arrow-down-bold-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }